<template>
  <div
    v-loading="loading"
    class="main-frame"
    :element-loading-text="$t('commonInfo.Loading')"
  >
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="24">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('commonInfo.checkScratchCode')"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>

      <el-main>
        <el-form
          class="search_table_info"
          ref="form"
          :inline="true"
          :model="form"
        >
          <el-form-item :label="$t('scratchCode.scratchCode')">
            <el-input
              v-model="scratch_code"
              clearable
              size="medium"
              :placeholder="$t('scratchCode.pleaseEnterScratchCode')"
            ></el-input>
          </el-form-item>
          <span class="example" style="margin-top: 10px">{{
            $t("scratchCode.scratchCodeExample")
          }}</span>
          <el-form-item>
            <el-button
              :disabled="scratch_code_length"
              type="primary"
              @click="check_scratch_code('text')"
              >{{ $t("scratchCode.manualCheck") }}</el-button
            >
          </el-form-item>

          <el-form-item style="float: right">
            <el-button type="primary" @click="trigger_upload_button">{{
              $t("scratchCode.uploadCheck")
            }}</el-button>
          </el-form-item>
          <el-form-item style="display: none" label="">
            <el-row>
              <el-col style="text-align: left" :span="16">
                <label class="btn btn-md btn-info" for="file_upload"></label>
                <input
                  ref="upload_file_button"
                  type="file"
                  name="file_upload"
                  @change="check_scratch_code('file', $event)"
                  accept=".xlsx"
                  multiple
                  id="file_upload"
                />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <!-- 人工核销结果 -->
        <el-form
          v-if="show_munual_form"
          ref="form"
          class="edit_module"
          :inline="true"
          :model="manual_form_result"
        >
          <el-form-item :label="$t('scratchCode.succeedTime')">
            <el-input
              disabled
              v-model.trim="manual_form_result.checked_count"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('scratchCode.failedTime')">
            <el-input
              disabled
              v-model.trim="manual_form_result.failed_count"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('scratchCode.repeatTime')">
            <el-input
              disabled
              v-model.trim="manual_form_result.repeated_count"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="
              manual_form_result.failed_code_list &&
              manual_form_result.failed_code_list.length > 0
            "
            class="failed_item"
            :label="$t('scratchCode.failedNumber')"
          >
            <el-input
              disabled
              v-model.trim="manual_form_result.failed_code_list"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      form: {},
      manual_form_result: {},
      scratch_code_list: [], //刮刮码表格
      show_munual_form: false,
      scratch_code: "",
      page_status: "",
      begin_time: "",
      end_time: "",
      // 分页部分
      page_total: 0,
      page_size: 15,
      page_number: 1,
    };
  },
  watch: {},
  computed: {
    scratch_code_length() {
      return this.scratch_code.length === 0;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    check_scratch_code: function (type, e) {
      let _me = this;
      _me.loading = true;
      this.show_munual_form = false;
      if (type === "file") {
        let btnId = "file_upload";
        let file = document.getElementById(btnId).files[0];
        // 文件上传核销
        if (file) {
          let reader = new FileReader();
          reader.readAsText(file, "UTF-8");
          reader.onload = function () {
            let formData = new FormData();
            formData.append("file", file);
            _me.$common
              .httpFilePost("/api/scratch/admin/code/check", formData)
              .then((res) => {
                _me.loading = false;
                // _me.check_result_show(res);
                let check_result_id = res.data.id;
                _me.get_scratch_code_item_info(check_result_id);
              })
              .catch((err) => {
                _me.loading = false;
                if (err.code == 1000009 || err.code == 1000007) {
                  _me.$router.push("sign-in");
                } else {
                  _me.$confirm(err.message, _me.$t("commonInfo.Tips"), {
                    confirmButtonText: _me.$t("commonInfo.Confirm"),
                    cancelButtonText: _me.$t("commonInfo.Cancel"),
                    type: "warning",
                  });
                }
              });
          };
        }
      } else if (type === "text") {
        //人工上传核销
        let params = {
          code_list: _me.scratch_code,
        };
        _me.$common
          .httpPost("/api/scratch/admin/code/check", params)
          .then((res) => {
            _me.loading = false;
            // _me.check_result_show(res);
            let check_result_id = res.data.id;
            _me.get_scratch_code_item_info(check_result_id);
          })
          .catch((err) => {
            _me.loading = false;
            if (err.code == 1000009 || err.code == 1000007) {
              this.$router.push("sign-in");
            }
            _me.$message.error(err.message);
          });
      }
    },
    check_result_show(res) {
      let _me = this;
      if (res.code == 1000000) {
        let check_result = `${_me.$t("scratchCode.currentSucceedTime")}${
          res.data.checked_count
        }${_me.$t("scratchCode.individual")},${_me.$t(
          "scratchCode.failedNumber"
        )}${res.data.failed_count}${_me.$t("scratchCode.individual")},${_me.$t(
          "scratchCode.repeatedCheck"
        )}${res.data.repeated_count}${_me.$t("scratchCode.individual")}`;
        _me.$confirm(check_result, _me.$t("commonInfo.Tips"), {
          confirmButtonText: _me.$t("commonInfo.Confirm"),
          cancelButtonText: _me.$t("commonInfo.Cancel"),
          type: "warning",
        });
      } else {
        _me.$confirm(res.message, _me.$t("commonInfo.Tips"), {
          confirmButtonText: _me.$t("commonInfo.Confirm"),
          cancelButtonText: _me.$t("commonInfo.Cancel"),
          type: "warning",
        });
      }
    },
    // 获取单项刮刮码全部数据
    get_scratch_code_item_info(id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: id,
      };
      this.$common
        .httpPost("/api/scratch/admin/check/log/find/id", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            Object.assign(_me.manual_form_result, res.data);
            this.show_munual_form = true;
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err);
        });
    },
    // 文件上传触发按钮
    trigger_upload_button() {
      this.$refs.upload_file_button.value = "";
      this.$refs.upload_file_button.click();
    },
  },
  created() {},
  mounted() {},
};
</script>
<style  scoped>
.example {
  font-size: 14px;
  color: #999;
}
main > form.edit_module {
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0;
}
main > form.edit_module > div {
  /* margin: 20px 0; */
  width: 25%;
  text-align: right;
  margin: 20px;
}
</style>
<style>
.failed_item label.el-form-item__label {
  color: red !important;
}
</style>